import { render, staticRenderFns } from "./TenthSection.vue?vue&type=template&id=7625358b&scoped=true&"
import script from "./TenthSection.vue?vue&type=script&lang=js&"
export * from "./TenthSection.vue?vue&type=script&lang=js&"
import style0 from "./TenthSection.vue?vue&type=style&index=0&id=7625358b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7625358b",
  null
  
)

export default component.exports